<template>
  <fieldset class="c-radio-list">
    <legend class="c-radio-list__title c-rap-radio-group__title--inline">
      {{ label }}
      <span v-if="required" class="c-radio-group__required">*</span>
   
    <div v-if="tooltip" class="c-tooltip">
      <ToolTip
        :title="tooltip.title"
        :isActive="isActiveTooltip"
        @toggleTooltip="(value) => $emit('toggleTooltip', value)"
      >
        <div v-if="tooltip.body" v-html="tooltip.body"></div>
        <img
          v-if="tooltip.image.url"
          :src="tooltip.image.url"
          :alt="tooltip.image.alt"
        />
      </ToolTip>
    </div>
  </legend>
    <CollapsibleContent
      v-if="collapsibleContent"
      :content="collapsibleContent"
    />
    <div class="c-rte helptext" v-if="helptext" v-html="helptext"></div>
    <validation-message
      :valid="valid"
      :invalid="invalid"
      :validationMessage="validationMessage"
    >
      <div class="c-radio-list__list">
        <label
          v-for="(option, index) in options"
          :key="index"
          class="c-radio-list__button"
          :class="{ 'is-active': isOptionActive(option) }"
          :for="`${groupName}-${index}`"
        >
          <input
            class="visually-hidden"
            :id="`${groupName}-${index}`"
            :name="groupName"
            type="radio"
            :value="option.value"
            v-model="selectedValue"
            @change="handleRadioClick(index, option)"
          />
          {{ option.label }}
      </label>
      </div>
    </validation-message>
  </fieldset>
</template>

<script>
  import CollapsibleContent from "../../_contact-us-rap/_vue/CollapsibleContent.vue";
  import ToolTip from "../../_contact-us-rap/_vue/ToolTip.vue";
  import ValidationMessage from "../../../../base/validation-message/ValidationMessage.vue";
  import { toSafeKey } from "../../_contact-us-rap/_vue/utils/toSafeKey";
  export default {
    inheritAttrs: false,
    components: {
      CollapsibleContent,
      ToolTip,
      ValidationMessage,
    },
    props: {
      id: {
        required: true,
        type: String,
      },
      label: {
        required: true,
        type: String,
      },
      required: {
        required: false,
        type: Boolean,
      },
      tooltip: {
        required: false,
        type: Object,
      },
      isActiveTooltip: {
        type: Boolean,
      },
      helptext: {
        type: String,
      },
      collapsibleContent: {
        type: Object,
      },
      value: [String, Number],
      valid: {
        type: Boolean,
        default: null,
      },
      invalid: {
        type: Boolean,
        default: null,
      },
      validationMessage: {
        required: false,
        type: String,
      },
      options: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        selectedValue: this.value,
      };
    },
    computed: {
      groupName() {
        return toSafeKey(this.label);
      },
      validationShow() {
        return this.valid || this.invalid ? true : false;
      },
      isOptionActive() {
        return (option) => option.value === this.selectedValue;
      },
    },
    watch: {
      value(newValue) {
        this.selectedValue = this.value;
      },
    },
    methods: {
      handleRadioClick(index, option) {
        this.selectedValue = option.value;
        this.$emit("change", index, option);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/forms/radio-list/RadioList.vue